import { z } from "zod";
export const companyInfo = z.object({
    id: z.string().uuid(), // tenants.public_id
    name: z.string(),
    code: z.string(),
    logoUrl: z.string().url().nullable(),
    createdAt: z.string().datetime(),
});
export const companiesListResponse = z.object({
    items: z.array(companyInfo),
});
export const updateCompanyRequest = z
    .object({
    name: z.string().min(1).max(255).optional(),
    code: z.string().min(1).max(100).optional(),
})
    .refine((v) => v.name !== undefined || v.code !== undefined, {
    message: "At least one field required",
});
//# sourceMappingURL=companies.schemas.js.map